import * as React from 'react';
import { PlatformsLink } from './PlatformsLink';
import { useMultiPostingPlatforms } from '../../../../../hooks';

export function PlatformsLinkContainer() {
  const platforms = useMultiPostingPlatforms();

  if (!platforms.length) {
    return <span>нескольких площадках</span>;
  }

  return <PlatformsLink platforms={platforms} />;
}
